import { useEffect } from 'react';
import { AccountId, PermissionId, ProjectId } from 'api/models';
import { ProjectChannel, pushes } from 'api/pushes';
import { useAccount } from './use-account';
import { useLatest } from './use-latest';
import { useUser } from './use-user';
export const useProjectWSUpdates = (projectId, handler, [action, objectType])=>{
    var _projects_projectId;
    const { permissions: { projects } } = useUser();
    const { accountId } = useAccount();
    const permissionId = (_projects_projectId = projects[projectId]) === null || _projects_projectId === void 0 ? void 0 : _projects_projectId.permissionSet.permissionSetId;
    const latestHandler = useLatest(handler);
    useEffect(()=>{
        let subscription;
        if (permissionId) {
            const channel = ProjectChannel(AccountId(accountId), PermissionId(permissionId), ProjectId(projectId));
            subscription = pushes(channel, [
                action,
                objectType
            ]).subscribe(latestHandler);
        }
        return ()=>subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
    }, [
        accountId,
        action,
        latestHandler,
        objectType,
        permissionId,
        projectId
    ]);
};
